import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { NotFound } from './NotFound'

export function RedirectHandler() {
  const location = useLocation()
  const [status, setStatus] = useState<'loading' | 'not_found'>('loading')

  useEffect(() => {
    const slug = location.pathname.replace(/^\/+|\/+$/g, '')
    if (!slug) {
      setStatus('not_found')
      return
    }

    fetch(`/api/redirects/resolve?slug=${encodeURIComponent(slug)}`)
      .then(r => {
        if (!r.ok) throw new Error('Not found')
        return r.json()
      })
      .then(data => {
        if (data.url) {
          window.location.href = data.url
        } else {
          setStatus('not_found')
        }
      })
      .catch(() => {
        setStatus('not_found')
      })
  }, [location.pathname])

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="flex items-center gap-3 text-muted-foreground">
          <span className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          Redirecting...
        </div>
      </div>
    )
  }

  return <NotFound />
}
